<div (click)="toggleCollapse()" class="collapsableSectionHeader">
  <div class="rubrik">{{ rubrik }}</div>
  <mat-icon [svgIcon]="expandIcon"></mat-icon>
</div>
@if (!collapsed) {
<ng-content> </ng-content>
}
